import { useQuery } from "@tanstack/react-query";

import { getQueryParams } from "app/pages/industry-analysis/common/getQueryParams";
import { getSelectedCategory } from "app/pages/industry-analysis/common/getSelectedCategory";
import { DefaultFetchService } from "app/services/fetchService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { DEVICE_DISTRIBUTION_ENDPOINT } from "../../../consts";
import type { IDeviceDistributionApiResponse, IDeviceDistributionChartData } from "../../../types";

const fetchDeviceDistributionData = (): Promise<IDeviceDistributionApiResponse> => {
    const fetchService = DefaultFetchService.getInstance();
    const baseParams = getQueryParams();
    const category = getSelectedCategory();

    const params = {
        ...baseParams,
        category: category.forApi,
        keys: category.forApi,
        categoryHash: "categoryHash" in category ? category.categoryHash : "",
        timeGranularity: "Monthly",
    };

    return fetchService.get<IDeviceDistributionApiResponse>(DEVICE_DISTRIBUTION_ENDPOINT, params);
};

const adaptApiData = (response: IDeviceDistributionApiResponse): IDeviceDistributionChartData => {
    const category = getSelectedCategory();
    const data = response.Data[category.forApi];
    return {
        desktop: data.Desktop,
        mobileWeb: data["Mobile Web"],
    };
};

export const useDeviceDistributionData = () => {
    const category = getSelectedCategory();
    const { duration, comparedDuration, country, includeSubdomains } = proNavigator.getParams();

    return useQuery({
        queryKey: ["device-distribution-single", category.id, duration, comparedDuration, country, includeSubdomains],
        queryFn: fetchDeviceDistributionData,
        select: adaptApiData,
    });
};
